import Select from 'react-select';
import DatePicker from 'react-datepicker';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, Box, Typography, OutlinedInput, InputAdornment, DialogActions } from '@mui/material';

import CloseIcon from 'app/components/Icons/CloseIcon';
import BinIcon from 'app/components/Icons/BinIcon';
import AmountInput from 'app/components/Filter/AmountInput';
import useFilter from 'app/components/Filter/useFilter';
import CalendarIcon from 'app/components/Icons/CalendarIcon';
import { OptionsWithIcon } from 'app/components/SelectOption';
import FilterIcon from 'app/components/Icons/FilterIcon';
import FieldError from 'app/components/FieldError';

import {
  btnsBox,
  closeBtn,
  dialogContent,
  dialogContentBoxes,
  dialogTitle,
  inputHeader,
  inputOutlined,
  paperProps,
  selectStyles,
  smallScreenBtnBox,
  btnFilter,
  notif,
  notifText,
  datePickerBox,
  dialogAction,
} from './Filter.sx';
import 'react-datepicker/dist/react-datepicker.css';
import DateInput from 'app/components/DateInput';
import dayjs from 'dayjs';

interface Props {
  pageName?: string;
  selectedAccount?: string;
  bg?: boolean;
  paymentType?: any;
  btnId?: number;
  setPaymentType?: any;
  voen?: any;
  setVoen?: any;
  client?: any;
  setClient?: any;
  selectedPeriod?: any;
  setSelectedPeriod?: any;
  resNextDate?: any;
  setNextResDate?: any;
  resEndDate?: any;
  setEndResDate?: any;
  fromAmount?: any;
  setFromAmount?: any;
  toAmount?: any;
  setToAmount?: any;
  filterCounter?: any;
  setFilterCounter?: any;
  showCount?: any;
  setShowCount?: any;
  mainCount?: any;
  setMainCount?: any;
  showFilter?: any;
  setShowFilter?: any;
  handleSubmitFilter?: () => void;
  isClean?: boolean;
  setIsClean?: any;
  resDate?: any;
  setResDate?: any;
  endDate?: any;
  setEndDate?: any;
  resetInputs?: () => void;
  setPage: any;
  handleCheckData: (id: number) => void;
  filterTransactionMutation: any;
  accNo: string;
  setAccNo: (data: string) => void;
}

const Filter = (props: Props) => {
  const {
    bg,
    pageName,
    selectedAccount,
    // searchValue,
    btnId,
    paymentType,
    setPaymentType,
    voen,
    setVoen,
    client,
    setClient,
    selectedPeriod,
    setSelectedPeriod,
    resNextDate,
    setNextResDate,
    resEndDate,
    setEndResDate,
    fromAmount,
    setFromAmount,
    toAmount,
    setToAmount,
    filterCounter,
    setFilterCounter,
    showCount,
    setShowCount,
    mainCount,
    setMainCount,
    showFilter,
    setShowFilter,
    // handleSubmitFilter,
    isClean,
    setIsClean,
    resDate,
    setResDate,
    endDate,
    setEndDate,
    // resetInputs,
    handleCheckData,
    setPage,
    filterTransactionMutation,
    accNo,
    setAccNo,
  } = props;
  const {
    t,
    options,
    smallScreen,
    handleChangePaymentType,
    handleChangeClient,
    handleChangeVoen,
    handlerChangeFromAmount,
    handlerChangeToAmount,
    register,
    errors,
    handleSubmit,
    handleSubmitFilter,
    resetAllInput,
    accounts,
    handlerNextDate,
    handlerEndDate,
  } = useFilter({
    setAccNo,
    accNo,
    selectedAccount,
    paymentType,
    btnId,
    setPaymentType,
    voen,
    setVoen,
    client,
    setClient,
    selectedPeriod,
    setSelectedPeriod,
    resNextDate,
    setNextResDate,
    resEndDate,
    setEndResDate,
    fromAmount,
    setFromAmount,
    toAmount,
    setToAmount,
    filterCounter,
    setFilterCounter,
    showCount,
    setShowCount,
    mainCount,
    setMainCount,
    showFilter,
    setShowFilter,
    isClean,
    setIsClean,
    resDate,
    setResDate,
    endDate,
    setEndDate,
    handleCheckData,
    setPage,
    filterTransactionMutation,
  });

  console.log('mainCount : ', mainCount);

  return (
    <>
      <Button
        color={'secondary'}
        sx={btnFilter(bg)}
        onClick={() => {
          setShowFilter(true);
        }}
      >
        <FilterIcon />

        {
         mainCount ? <Box sx={notif}>
            <Typography sx={notifText}>{mainCount}</Typography>
          </Box> : ''
        }
      </Button>
      <Dialog
        open={showFilter}
        PaperProps={{
          sx: paperProps,
        }}
        onClose={() => {
          setShowFilter(false);
        }}
      >
        <DialogTitle sx={dialogTitle}>
          <Typography sx={{ fontSize: '22px', fontWeight: '600' }}>{t('homePage.filter')}</Typography>
          <Button
            color={'secondary'}
            onClick={() => {
              setShowFilter(false);
            }}
            sx={closeBtn}
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <form style={{ display: 'contents' }} onSubmit={handleSubmit(handleSubmitFilter)}>
          <DialogContent sx={dialogContent}>
            {pageName !== 'payment-orders' && (
              <>
                <Box sx={dialogContentBoxes}>
                  <Typography sx={inputHeader}>{t('homePage.account')}</Typography>
                  <Select
                    styles={selectStyles}
                    isSearchable={false}
                    options={accounts}
                    placeholder={t('homePage.account')}
                    components={{
                      IndicatorSeparator: () => null,
                      Option: OptionsWithIcon,
                    }}
                    value={accNo}
                    onChange={setAccNo}
                  />
                </Box>
                <Box sx={dialogContentBoxes}>
                  <Typography sx={inputHeader}>{t('homePage.trType')}</Typography>
                  <Select
                    styles={selectStyles}
                    isSearchable={false}
                    options={options}
                    placeholder={t('homePage.trType')}
                    components={{
                      IndicatorSeparator: () => null,
                      Option: OptionsWithIcon,
                    }}
                    value={paymentType}
                    onChange={handleChangePaymentType}
                  />
                </Box>
                <Box sx={dialogContentBoxes}>
                  <Typography sx={inputHeader}>{t('homePage.rcName')}</Typography>
                  <OutlinedInput
                    placeholder={t('homePage.rcName')}
                    sx={{ ...inputOutlined, '& .MuiOutlinedInput-input': { padding: '0px' } }}
                    value={client}
                    onChange={(e: any) => handleChangeClient(e)}
                  />
                </Box>
                <Box sx={dialogContentBoxes}>
                  <Typography sx={inputHeader}>{t('homePage.rcTaxId')}</Typography>
                  <OutlinedInput
                    placeholder={t('homePage.rcTaxId')}
                    sx={{ ...inputOutlined, '& .MuiOutlinedInput-input': { padding: '0px' } }}
                    value={voen}
                    onChange={(e: any) => handleChangeVoen(e)}
                    inputProps={{
                      ...register('taxId'),
                      maxLength: 10,
                    }}
                  />
                  <FieldError error={errors.taxId} />
                </Box>
              </>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <>
                <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                  <Typography sx={{ fontSize: '15px', fontWeight: 400, lineHeight: '18px' }}>
                    {t('homePage.paymentPeriod')}
                  </Typography>
                  <Box sx={datePickerBox}>
                    <DateInput
                      selectedDate={resDate}
                      minDate={dayjs('05-24-2005')}
                      maxDate={endDate || dayjs(new Date())}
                      onDateChange={handlerNextDate}
                      placeholder={t('homePage.fromDate')}
                      label={'date'}
                    />
                    <DateInput
                      selectedDate={endDate}
                      minDate={resDate || dayjs('05-24-2005')}
                      maxDate={dayjs(new Date())}
                      onDateChange={handlerEndDate}
                      placeholder={t('homePage.toDate')}
                      label={'date'}
                    />
                  </Box>
                </Box>
              </>
            </Box>
            <Box sx={{ ...dialogContentBoxes, mb: '12px' }}>
              <Typography sx={inputHeader}>{t('homePage.amountRange')}</Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
                <AmountInput
                  value={fromAmount}
                  handleChange={handlerChangeFromAmount}
                  placeholder={t('homePage.fromAmount')}
                />
                <AmountInput
                  value={toAmount}
                  handleChange={handlerChangeToAmount}
                  placeholder={t('homePage.toAmount')}
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={dialogAction}>
            <Box sx={{ ...btnsBox, width: '100%' }}>
              {isClean && (
                <Button
                  color={'tertiary'}
                  sx={{ display: 'flex', gap: '12px', '& .MuiSvgIcon-root': { width: '22px', height: '22px' } }}
                  onClick={resetAllInput}
                >
                  <BinIcon sx={{ fill: 'transparent' }} />
                  {t('homePage.resetFilters')}
                </Button>
              )}
              <Button type={'submit'}>{t('homePage.confirm')}</Button>
            </Box>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default Filter;
